/* ── Mark-1 Performance Theme JS ── */

// Nav scroll effect
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 80);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// Fade-in on scroll
(function () {
  const els = document.querySelectorAll('.fade-in');
  if (!els.length) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  els.forEach(el => io.observe(el));
})();

// Animated counters (Ingredients section)
(function () {
  const counters = document.querySelectorAll('[data-counter]');
  if (!counters.length) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target;
      const to = parseFloat(el.dataset.counter);
      const unit = el.dataset.unit || '';
      const duration = 1200;
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * to) + unit;
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      io.unobserve(el);
    });
  }, { threshold: 0.3 });
  counters.forEach(el => io.observe(el));
})();

// Product page: quantity selector
(function () {
  const qtyDisplay = document.getElementById('qty-display');
  const qtyInput = document.getElementById('qty-input');
  const decreaseBtn = document.getElementById('qty-decrease');
  const increaseBtn = document.getElementById('qty-increase');
  const addToCartBtn = document.getElementById('add-to-cart-btn');
  const priceDisplay = document.getElementById('btn-price');
  const basePrice = parseFloat(document.getElementById('base-price')?.dataset.price || 39);

  if (!qtyDisplay || !qtyInput) return;

  let qty = 1;

  function updateQty(newQty) {
    qty = Math.max(1, Math.min(10, newQty));
    qtyDisplay.textContent = qty;
    qtyInput.value = qty;
    if (decreaseBtn) decreaseBtn.disabled = qty <= 1;
    if (increaseBtn) increaseBtn.disabled = qty >= 10;
    if (priceDisplay) priceDisplay.textContent = '$' + (basePrice * qty).toFixed(0);
  }

  if (decreaseBtn) decreaseBtn.addEventListener('click', () => updateQty(qty - 1));
  if (increaseBtn) increaseBtn.addEventListener('click', () => updateQty(qty + 1));

  // Add to cart feedback
  if (addToCartBtn) {
    const form = addToCartBtn.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        const originalText = addToCartBtn.textContent;
        addToCartBtn.textContent = 'ADDED TO CART ✓';
        addToCartBtn.disabled = true;
        setTimeout(() => {
          addToCartBtn.textContent = originalText;
          addToCartBtn.disabled = false;
        }, 1800);
      });
    }
  }
})();

// Waitlist form
(function () {
  const form = document.getElementById('waitlist-form');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const emailInput = form.querySelector('input[type="email"]');
    if (emailInput && emailInput.value.trim()) {
      form.innerHTML = '<p class="purchase__success">You\'re on the list.</p>';
    }
  });
})();

// Hero cursor glow
(function () {
  const hero = document.querySelector('.hero');
  if (!hero) return;
  const glow = document.createElement('div');
  glow.className = 'hero__cursor-glow';
  glow.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:1;opacity:0;transition:opacity 0.3s;background:radial-gradient(650px circle at 50% 50%,rgba(107,33,168,0.18) 0%,rgba(13,148,136,0.09) 45%,transparent 70%)';
  hero.appendChild(glow);

  hero.addEventListener('mousemove', (e) => {
    const rect = hero.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    glow.style.backgroundImage = `radial-gradient(650px circle at ${x}% ${y}%,rgba(107,33,168,0.18) 0%,rgba(13,148,136,0.09) 45%,transparent 70%)`;
    glow.style.opacity = '0.15';
  });

  hero.addEventListener('mouseleave', () => { glow.style.opacity = '0'; });
})();
